import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import { LeadCard } from "@/components/pipeline/LeadCard";

/** Desktop Kanban board with drag-and-drop between pipeline stages. */
export const KanbanBoard = ({ columns, onDragEnd }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="flex gap-4 overflow-x-auto pb-4" data-testid="kanban-board">
        {columns.map((col) => (
          <div key={col.stage.id} className="flex w-72 shrink-0 flex-col rounded-xl border border-border bg-secondary/40" data-testid={`kanban-column-${col.stage.code}`}>
            <div className="flex items-center justify-between border-b border-border px-3 py-2.5">
              <span className="text-sm font-semibold text-foreground">{col.stage.name}</span>
              <span className="rounded-full bg-background px-2 py-0.5 text-xs font-medium text-muted-foreground">{col.leads.length}</span>
            </div>
            <Droppable droppableId={col.stage.id}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={`min-h-[120px] flex-1 space-y-2 p-2 transition-colors ${snapshot.isDraggingOver ? "bg-brand-gold/5" : ""}`}
                >
                  {col.leads.map((lead, index) => (
                    <Draggable key={lead.id} draggableId={lead.id} index={index}>
                      {(dp, ds) => (
                        <div ref={dp.innerRef} {...dp.draggableProps} {...dp.dragHandleProps}>
                          <LeadCard lead={lead} dragging={ds.isDragging} />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  {col.leads.length === 0 && !snapshot.isDraggingOver && (
                    <p className="px-2 py-6 text-center text-xs text-muted-foreground">Drop leads here</p>
                  )}
                </div>
              )}
            </Droppable>
          </div>
        ))}
      </div>
    </DragDropContext>
  );
};
